import React from "react";
import "./DigitalSignageAreaFooter.scss";
import {
  ConversionType,
  getMaxConvertedValueFromArray,
  formatCurrency,
} from "@EMaaS/EMaaS.consup.react.widget.energymanagement";
import reddownarrow from "../../assets/image/reddownarrow.svg";
import { IDigitalSignageData } from "./DigitalSignageViewContainer";

type DigitalSignageAreaFooterProps = {
  highlightedIndex: number;
  getDIgitalSignageData: IDigitalSignageData;
  theme: boolean;
};
export const isNotNegative = (value: number) => value > 0;
const DigitalSignageAreaFooter = (props: DigitalSignageAreaFooterProps) => {
  const { electricity, gas, water, carbon, savings } =
    props.getDIgitalSignageData;
  const { highlightedIndex, theme } = props;

  const summary =
    electricity && electricity.summary && electricity.summary.actual
      ? // && isNotNegative(electricity.summary.actual)
        [electricity.summary.actual]
      : [];
  const summaryGas =
    gas && gas.summary && gas.summary.actual
      ? // && isNotNegative(gas.summary.actual)
        [gas.summary.actual]
      : [];
  const summaryWater =
    water && water.summary && water.summary.actual
      ? // && isNotNegative(water.summary.actual)
        [water.summary.actual]
      : [];
  const summaryCarbon =
    carbon && carbon.summary && carbon.summary.actual
      ? // && isNotNegative(carbon.summary.actual)
        [carbon.summary.actual]
      : [];
  const summaryCost =
    savings && savings.summary && savings.summary.actual
      ? // && isNotNegative(savings.summary.actual)
        [savings.summary.actual]
      : [];
  const unit =
    electricity && electricity.unit ? electricity.unit : "kilowatt hour";
  const unitGas = gas && gas.unit ? gas.unit : "mmbtu";
  const unitWater = water && water.unit ? water.unit : "liter";
  const unitCarbon = carbon && carbon.unit ? carbon.unit : "metric ton";
  const unitCost = savings && savings.unit ? savings.unit : "USD";
  const stats = [
    {
      label: "Electricity Savings",
      value: summary,
      unit: unit,
      type: ConversionType.ELECTRICITY,
      gradient: "linear-gradient(to bottom, #FFA5F700 10%, #B174EA66 80%)",
      isEnable:electricity?.isEnabled
    },
    {
      label: "Natural Gas Savings",
      value: summaryGas,
      unit: unitGas,
      type: ConversionType.GAS,
      gradient: "linear-gradient(to bottom, #FFAC2500 10%, #FFAC2599 80%)",
      isEnable:gas?.isEnabled
    },
    {
      label: "Water Savings",
      value: summaryWater,
      unit: unitWater,
      type: ConversionType.WATER,
      gradient:
        "linear-gradient(to bottom, #08778900 10%, #08778966 80%) padding-box",
      isEnable:water?.isEnabled
    },
    {
      label: "Carbon Reduced",
      value: summaryCarbon,
      unit: unitCarbon,
      type: ConversionType.CARBON,
      gradient: "linear-gradient(to bottom, #61DDBA00  10%, #13896766 80%)",
      isEnable:carbon?.isEnabled
    },
    {
      label: "Total Savings",
      value: summaryCost,
      unit: unitCost,
      type: "cost",
      gradient: "linear-gradient(to bottom, #CB7C7800  10%, #CB7C7866 80%)",
      isEnable:savings?.isEnabled
    },
  ];

  return (
    <div className="energy-footer-section">
      {stats.map((val, index) => {
        if (!val.isEnable) {
          return null;
        }
        let maxValueUnitConversion, costValueUnitConversion;
        if (val.type === "cost") {
          costValueUnitConversion =
            val.value.length > 0
              ? formatCurrency(val.value.map((v) => Math.abs(v))[0], val.unit)
              : "--";
        } else {
          maxValueUnitConversion =
            val.value.length > 0
              ? getMaxConvertedValueFromArray(
                  val.type,
                  val.unit,
                  val.value.map((v) => Math.abs(v))
                )
              : { Value: "--", Unit: "" };
        }

        return (
          <div
            key={index}
            className={`stat-card ${
              index === highlightedIndex ? "highlighted" : "dimmed"
            }`}
            style={
              index === highlightedIndex
                ? {
                    background: val.gradient,
                    transform: "scale(1.19)",
                    borderRadius: "1.5rem",
                    transition: "all 0.3s ease",
                    zIndex: 1,
                  }
                : {}
            }
          >
            <div className={`label ${theme ? "dark-label" : "light-label"}`}>
              {val.label}
            </div>
            <div className="value">
              {val.type === "cost" ? (
                <>
                 {val.value.length > 0 && !isNotNegative(val.value[0]) && (
                    <img className="negativeArrow" src={reddownarrow} />
                  )}
                   <span
                  className={`value-number ${
                    theme ? "dark-value-number" : "light-value-number"
                  }`}
                >
                  {costValueUnitConversion}
                </span></>
               
              ) : (
                <>
                  {val.value.length > 0 && !isNotNegative(val.value[0]) && (
                    <img className="negativeArrow" src={reddownarrow} />
                  )}
                  <span
                    className={`value-number ${
                      theme ? "dark-value-number" : "light-value-number"
                    }`}
                  >
                    {maxValueUnitConversion?.Value}
                  </span>
                  <span
                    className={`unit ${theme ? "dark-unit" : "light-unit"}`}
                  >
                    {maxValueUnitConversion?.Unit}
                  </span>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DigitalSignageAreaFooter;
